<template>
  <div class="mt-4">
    <b-table
      :fields="fields"
      :items="itens"
      :empty-text="$t('GERAL.NENHUM_REGISTRO')"
      head-variant="light"
      responsive="sm"
      stacked="md"
      show-empty
      striped
      @sort-changed="aoMudarOrdenacao"
    />
  </div>
</template>
<script>
// Utils & Aux:
import helpers from '@/common/utils/helpers';

export default {
  name: 'TabelaBalancete',
  props: {
    itens: {
      type: Array,
      default: Array,
    },
  },
  data() {
    return {
      fields: [
        {
          key: 'estrutural',
          label: 'Código Conta',
          sortable: true,
        },
        {
          key: 'nomeConta',
          label: 'Nome da Conta',
          sortable: true,
        },
        {
          key: 'saldoAnterior',
          label: this.$t('CONTABIL.SALDO_ANTERIOR'),
          class: 'text-right',
          sortable: true,
          formatter: (value) => {
            if (value) return helpers.formatacaoMoedaBRL(Math.abs(value));
          },
        },
        {
          key: 'tipoValorPeriodoAnterior',
          label: this.$t('CONTABIL.TIPO_MOVIMENTO'),
          class: 'text-center',
          sortable: true
        },
        {
          key: 'debito',
          label: this.$t('CONTABIL.DEBITOS'),
          sortable: true,
          class: 'text-right',
          formatter: (value) => {
            if (value) return helpers.formatacaoMoedaBRL(Math.abs(value));
          },
        },
        {
          key: 'credito',
          label: this.$t('CONTABIL.CREDITOS'),
          sortable: true,
          class: 'text-right',
          formatter: (value) => {
            if (value) return helpers.formatacaoMoedaBRL(Math.abs(value));
          },
        },
        {
          key: 'saldoAtual',
          label: this.$t('CONTABIL.SALDO_ATUAL'),
          sortable: true,
          class: 'text-right',
          formatter: (value) => {
            if (value) return helpers.formatacaoMoedaBRL(Math.abs(value));
          },
        },
        {
          key: 'tipoValorPeriodoSaldo',
          label: this.$t('CONTABIL.TIPO_MOVIMENTO'),
          class: 'text-center',
          sortable: true
        },
      ],
    };
  },
  methods: {
    remover(item) {
      this.$emit('remover', item);
    },
    aoMudarOrdenacao({ sortBy, sortDesc }) {
      let campoOrdenado = helpers.primeiraLetraMaiuscula(sortBy)
      let ordem = sortDesc
      this.$emit('alterar-ordenacao', campoOrdenado, ordem);
    },
  },
};
</script>
